/* Angular */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';

/* Components */
import { TestHarnessComponent } from './components/test-harness';
//import { RoleFormEditorComponent } from './components/roleform-editor';
//import { FormEditorComponent } from './components/form-editor';
//import { FieldEditorComponent } from './components/field-editor';

//Modules
import { SharedModule } from '../shared/shared.module';

const routes = [
    { 
        path:"test-harness", component:TestHarnessComponent,
        children : [
            //{ path : "role-form-editor", component:RoleFormEditorComponent },
            //{ path : "form-editor", component:FormEditorComponent },
            //{ path : "field-editor", component:FieldEditorComponent }
        ]
    }
];

@NgModule({
    imports : [
        CommonModule,
        FormsModule,
        HttpClientModule,
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations : [
        TestHarnessComponent,
        //RoleFormEditorComponent,
        //FormEditorComponent,
        //FieldEditorComponent
    ],
    providers : [

    ],
    exports : [
        RouterModule
    ]
})
export class TestHarnessModule{

}